import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSendLoad extends Layout {
    panelZmitSwitches: Panel;
    sourceEquipmentGroup: DataSource;
    sourceZmitLoad: DataSource;
    switchDispatchEmpty: Switch;
    switchFuelOptimization: Switch;
    textboxDriver: Textbox;
    textboxTractorId: Textbox;
}
